import { useState } from 'react';
import { toast } from "sonner";

// Maximum file size in bytes (50MB)
export const MAX_FILE_SIZE = 50 * 1024 * 1024;
// Maximum video duration in seconds
export const MAX_VIDEO_DURATION = 15;

export const useFileUpload = () => {
  const [file, setFile] = useState<File | null>(null);

  const checkVideoDuration = (file: File): Promise<boolean> => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        if (video.duration > MAX_VIDEO_DURATION) {
          toast.error(`Video must be ${MAX_VIDEO_DURATION} seconds or less. This video is ${Math.round(video.duration)} seconds.`);
          resolve(false);
        }
        resolve(true);
      };

      video.src = URL.createObjectURL(file);
    });
  };

  const validateFile = async (file: File) => {
    if (file.type.startsWith('video/')) {
      const isValidDuration = await checkVideoDuration(file);
      if (!isValidDuration) return false;
    }
    
    if (file.size > MAX_FILE_SIZE) {
      toast.error("File size must be less than 50MB");
      return false;
    }
    return true;
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    console.log('Selected file:', selectedFile.name, 'Size:', selectedFile.size / 1024 / 1024, 'MB');

    if (await validateFile(selectedFile)) {
      setFile(selectedFile);
    } else {
      e.target.value = '';
    }
  };

  return {
    file,
    setFile,
    handleFileChange
  };
};